export function mapToFilter(map) {
    var filter = []
    map.forEach((value, key) =>
        filter.push({
            text: value,
            value: key 
        })
    )
    return filter
}